import React from 'react';
import { Download, FileText, Table } from 'lucide-react';
import { exportCSV, exportExcel } from '../utils/api';
import { useT } from '../i18n';

const ExportButtons = ({ size = 'md' }) => {
  const t = useT();
  const handleExportCSV = () => {
    exportCSV();
  };

  const handleExportExcel = () => {
    exportExcel();
  };

  const btnClass = size === 'lg' 
    ? 'btn-primary h-12 px-6 text-base'
    : 'btn-primary';

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={handleExportCSV}
        className={btnClass + ' flex items-center gap-2'}
        data-testid="export-csv-button"
      >
        <FileText className={size === 'lg' ? 'h-5 w-5' : 'h-4 w-4'} />
        {t('export.csv')}
      </button>
      <button
        onClick={handleExportExcel}
        className={btnClass + ' flex items-center gap-2'}
        data-testid="export-excel-button"
      >
        <Table className={size === 'lg' ? 'h-5 w-5' : 'h-4 w-4'} />
        {t('export.excel')}
      </button>
    </div>
  );
};

export default ExportButtons;